import { Country } from './country';

export interface Subject {
  id?: string; // Optional when creating, required when returned from API
  subjectName: string;
  subjectType: SubjectType;
  jurisdictions: Country[];
  reference?: string;
  externalProjectId?: string;
  additionalInfo?: Record<string, unknown> | null;
  teamId?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export enum SubjectType {
  Company = 'Company',
  Person = 'Person',
  /** A ship, identified by its IMO number (`additional_info.imo_number`). */
  Vessel = 'Vessel',
}

export enum SubjectScopeType {
  ENHANCED_DUE_DILIGENCE = 'Enhanced Due Diligence',
  DESKTOP_RESEARCH = 'Desktop Research',
  IN_COUNTRY = 'In-Country Research',
  GDM_1Y = 'GDM-1Y',
  GDM_1X = 'GDM-1X',
  GDM_3G = 'GDM-3G',
}

export interface ApiSubject {
  id: string;
  subject_name: string;
  subject_type: SubjectType;
  jurisdictions: Country[];
  reference?: string;
  external_project_id?: string;
  additional_info?: Record<string, unknown> | null;
  team_id?: string | null;
  created_at?: string;
  updated_at?: string | null;
}
